import BigNumber from 'bignumber.js';

import { VBep20, VBnbToken, UmiToken, UmiVault,DlVault } from 'types/contracts';

export interface GetOutroiInput {
  dlVaultContract: DlVault;
  accountAddress: string;

}

export type GetOutroiOutput = {
  inviter: string;
};

const getOutroi = async ({
  dlVaultContract,
                               accountAddress,
}: GetOutroiInput): Promise<GetOutroiOutput> => {
  const res = await dlVaultContract.methods.outroi().call();

  return {
    inviter: res,
  };
};

export default getOutroi;
